import { Injectable, inject } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { SysUtilService } from './sysUtil.service';
import { env } from '../../../app.constant';


@Injectable()
export class RegistryReportService {

    private sysUtil: SysUtilService = inject(SysUtilService);

    private initialPosition = 9;

    // private numberFormat = "#,##0.00";
    private numberFormat = "#,##0.00_);[Black](#,##0.00)";

    private fontStyle = {
        header: { name: 'Arial Narrow', size: 10, bold: true },
        content: { name: 'Arial Narrow', size: 10 }
    };
    private columns = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K'
    ];
    private columnTitle = [
        'Date', 'Date', 'Serial Number', 'UACS Object Code / Expenditures', 'Budgeted Amount', 'Utilization', 'Unutilized Budgeted Amount', 'Disbursement', 'Due Demandable', 'Not Yet Due and Demandable', 'ORS No. / CAA'
    ];
    private borderStyle: any = {
        thin: { style: 'thin' },
        full: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        },
        topBottom: {
            top: { style: 'thin' },
            bottom: { style: 'thin' }
        },
        leftRight: {
            left: { style: 'thin' },
            right: { style: 'thin' }
        },
        topLeft: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        topRight: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomLeft: {
            bottom: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomRight: {
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };

    // private formula: any = {
    //     e: `IF(OR(NOT(C*=""),NOT(D*="")),IF(C*="",0,C*)+IF(D*="",0,D*),"")`,
    //     j: `IF(OR(NOT(F*=""), NOT(G*=""), NOT(H*=""), NOT(I*="")), IF(F*="",0,F*) + IF(G*="",0,G*) + IF(H*="",0,H*) + IF(I*="",0,I*), "")`,
    //     o: `IF(OR(NOT(K*=""), NOT(L*=""), NOT(M*=""), NOT(N*="")), IF(K*="",0,K*) + IF(L*="",0,L*) + IF(M*="",0,M*) + IF(N*="",0,N*), "")`,

    //     p: `IF(OR(NOT(F*=""), NOT(K*="")), IF(F*="",0,F*) + IF(K*="",0,K*), "")`,
    //     q: `IF(OR(NOT(G*=""), NOT(L*="")), IF(G*="",0,G*) + IF(L*="",0,L*), "")`,
    //     r: `IF(OR(NOT(H*=""), NOT(M*="")), IF(H*="",0,H*) + IF(M*="",0,M*), "")`,
    //     s: `IF(OR(NOT(I*=""), NOT(N*="")), IF(I*="",0,I*) + IF(N*="",0,N*), "")`,
    //     t: `IF(OR(NOT(P*=""), NOT(Q*=""), NOT(R*=""), NOT(S*="")), IF(P*="",0,P*) + IF(Q*="",0,Q*) + IF(R*="",0,R*) + IF(S*="",0,S*), "")`,
    //     y: `IF(OR(NOT(U*=""), NOT(V*=""), NOT(W*=""), NOT(X*="")), IF(U*="",0,U*) + IF(V*="",0,V*) + IF(W*="",0,W*) + IF(X*="",0,X*), "")`,
    //     ad: `IF(OR(NOT(Z*=""), NOT(AA*=""), NOT(AB*=""), NOT(AC*="")), IF(Z*="",0,Z*) + IF(AA*="",0,AA*) + IF(AB*="",0,AB*) + IF(AC*="",0,AC*), "")`,
    //     ae: `IF(OR(NOT(T*=""), NOT(Y*="")), IF(T*="",0,T*) - IF(Y*="",0,Y*), "")`,
    //     // ag: `IF(OR(NOT(Y*=""), NOT(AD*="")), IF(Y*="",0,Y*) - IF(AD*="",0,AD*), "")`,
    //     ah: `IF(OR(NOT(E*=""), NOT(J*="")), IF(E*="",0,E*) - IF(J*="",0,J*), "")`,
    // };

    private formula: any = {
        g: `IF(E*="",0,E*) - IF(F*="",0,F*)`,
        j: `IF(F*="",0,F*) - IF(H*="",0,H*) - IF(I*="",0,I*)`
    }

    async createWorkSheets(wb: ExcelJS.Workbook, content: Array<any>, caa_data: Array<any>, campus: number, year: number, uacs: string, sn: string, fund: string) {
        let data = JSON.parse(JSON.stringify(content));
        let selected_campus = env.campuses.find((c: any) => c.value == campus);
        let sheet_name = (sn.length > 31) ? sn.substring(0, 31) : sn;
        const ws = wb.addWorksheet(sheet_name);

        ws.columns = [
            { header: "", key: "date1", width: 13 },
            { header: "", key: "date2", width: 13 },
            { header: "", key: "serial_number", width: 27 },
            { header: "", key: "uacs_expenditures", width: 21 },
            { header: "", key: "budgeted_amount", width: 17 },
            { header: "", key: "utilization", width: 17 },
            { header: "", key: "unutilized_budgeted_amount", width: 17 },
            { header: "", key: "disbursement", width: 17 },
            { header: "", key: "due_demandable", width: 17 },
            { header: "", key: "not_yet_due", width: 17 },
            { header: "", key: "ors_caa_number", width: 27 }
        ];

        const allotmentClass = env.allotment_class[uacs.substring(1, 3)];
        this.setHeader(ws, selected_campus, fund, allotmentClass, year);

        let position = this.initialPosition + 2;
        let amt_columnn = ['E', 'F', 'G', 'H', 'I', 'J'];
        let amt_property = [
            'budgeted_amount',
            'utilization',
            'unutilized_budgeted_amount',
            'disbursement',
            'due_demandable',
            'not_yet_due'
        ];
        data.forEach((data: any, i: number) => {
            amt_property.forEach((prop: string, index: number) => {
                data[prop] = (Number(data[prop]) == 0) ? "" : Number(data[prop]);
            });

            data.date1 = this.formatDate(data.date1);
            data.date2 = this.formatDate(data.date2);

            ws.addRow(data);

            let rowNum = position + i;
            this.columns.forEach((col: string) => {
                let cell = ws.getCell(`${col}${rowNum}`);
                if (amt_columnn.includes(col)) {
                    if (['G', 'J'].includes(col)) {
                        if ((rowNum > 11)) {
                            cell.value = { formula: `IF(${col}${rowNum - 1}="",0,${col}${rowNum - 1}) + ${this.formula[col.toLowerCase()].replaceAll('*', rowNum)}`, date1904: false };
                        }
                    }
                    cell.style = { numFmt: this.numberFormat };
                }
                cell.font = this.fontStyle.content;
                cell.border = this.borderStyle.full;
                cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
            });
        });

        this.columns.forEach((col: string) => {
            let cell = ws.getCell(`${col}${position + data.length}`);
            let is_amt = false;
            if (amt_columnn.includes(col)) {
                cell.value = ws.getCell(`${col}${position + data.length - 1}`).value;
                if (!['G', 'J'].includes(col)) {
                    cell.value = { formula: `SUM(${col}${position}:${col}${position + data.length - 1})`, date1904: false };
                }
                cell.style = { numFmt: this.numberFormat };
                is_amt = true;
            }
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (is_amt) ? 'right' : 'center' };
        });

        ws.mergeCells(`A${position + data.length}:D${position + data.length}`);
        ws.getCell(`A${position + data.length}`).value = `Total`;

        let caaPosition = position + data.length + 1;

        // spacer of before caa
        ws.addRow({});
        let rowNum = caaPosition;
        this.columns.forEach((col: string) => {
            let cell = ws.getCell(`${col}${rowNum}`);
            if (col === 'A') {
                cell.value = 'Earmark Budget with Certificate of Availability of Allotment';
            }
            if (amt_columnn.includes(col)) {
                cell.style = { numFmt: this.numberFormat };
            }
            cell.font = this.fontStyle.content;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
        });
        ws.mergeCells(`A${rowNum}:C${rowNum}`);

        let caa_earmark_data = [];

        caaPosition += 1;
        let initCaaPosition = caaPosition;
        // insert the caa data after the total row
        caa_data.forEach((caaItem: any, index: number) => {
            let orsforCaa = data.filter((d: any) => d.ors_caa_number == caaItem.caa_no);

            caa_earmark_data.push({
                date1: caaItem.caa_date,
                date2: caaItem.caa_date,
                serial_number: caaItem.caa_no,
                uacs_expenditures: caaItem.acct_uacs_code,
                budgeted_amount: '',
                utilization: Number(caaItem.amount),
                unutilized_budgeted_amount: '',
                disbursement: '',
                due_demandable: '',
                not_yet_due: '',
                ors_caa_number: orsforCaa.map(ors => ors.serial_number).join(', ') || '',

            });

            for (let i = 0; i < orsforCaa.length; i++) {
                caa_earmark_data.push({
                    date1: orsforCaa[i].date1,
                    date2: orsforCaa[i].date2,
                    serial_number: orsforCaa[i].serial_number,
                    uacs_expenditures: orsforCaa[i].uacs_expenditures,
                    budgeted_amount: '',
                    utilization: Number(orsforCaa[i].utilization) * -1,
                    unutilized_budgeted_amount: '',
                    disbursement: '',
                    due_demandable: '',
                    not_yet_due: '',
                    ors_caa_number: '',
                });
            }
        });


        let sorted_caa = caa_earmark_data.sort((a, b) => {
            const dateA = new Date(a.date1);
            const dateB = new Date(b.date1);
            if (dateA.getTime() !== dateB.getTime()) {
                return dateA.getTime() - dateB.getTime();
            }
            return new Date(a.date2).getTime() - new Date(b.date2).getTime();
        });

        sorted_caa.forEach((data: any, i: number) => {
            ws.addRow(data);
            let rowNum = caaPosition + i;
            this.columns.forEach((col: string) => {
                let cell = ws.getCell(`${col}${rowNum}`);
                if (col == 'G') {
                    let rn = (i == 0) ? rowNum - 2 : rowNum - 1;
                    cell.value = { formula: `IF(G${rn}="",0,G${rn}) - IF(F${rowNum}="",0,F${rowNum})`, date1904: false };
                }
                if (amt_columnn.includes(col)) {
                    cell.style = { numFmt: this.numberFormat };
                }
                cell.font = this.fontStyle.content;
                cell.border = this.borderStyle.full;
                cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
            });
        });

        // this is for total of caa
        ws.addRow({});
        caaPosition += sorted_caa.length;
        this.columns.forEach((col: string) => {
            let cell = ws.getCell(`${col}${caaPosition}`);
            if (col === 'A') {
                cell.value = 'Total';
            }
            if (col == 'G') {
                cell.value = { formula: `G${caaPosition - 1}`, date1904: false };
            }
            if (col == 'F') {
                cell.value = { formula: `SUM(F${initCaaPosition}:${'F'}${caaPosition - 1})`, date1904: false };
            }
            if (amt_columnn.includes(col)) {
                cell.style = { numFmt: this.numberFormat };
            }
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
        });
        ws.mergeCells(`A${caaPosition}:D${caaPosition}`);

    }

    async generateExcel(content: Array<any>, campus: number, year: number, fund_name: string, allotment_class: string, caa_data: Array<any> = [], options: any = { fileName: "RBUD", sheetName: "Sheet1" }) {

        let data = JSON.parse(JSON.stringify(content));
        let selected_campus = env.campuses.find((c: any) => c.value == campus);
        options.fileName = `RBUD_${fund_name.replaceAll(' ', '-')}_${allotment_class.replaceAll(' ', '-')}_${selected_campus?.text.replaceAll(' ', '')}`;

        // content.forEach((d: any) => {
        //     let dt = JSON.parse(JSON.stringify(d));
        //     // dt.fnd_name = d.fnd_name.replaceAll(/(<([^>]+)>)|(\&nbsp;)/ig, '');
        //     data.push(dt);
        // });

        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet(options.sheetName);
        // const ws = wb.getWorksheet(options.sheetName);

        ws.columns = [
            { header: "", key: "date1", width: 13 },
            { header: "", key: "date2", width: 13 },
            { header: "", key: "serial_number", width: 27 },
            { header: "", key: "uacs_expenditures", width: 21 },
            { header: "", key: "budgeted_amount", width: 17 },
            { header: "", key: "utilization", width: 17 },
            { header: "", key: "unutilized_budgeted_amount", width: 17 },
            { header: "", key: "disbursement", width: 17 },
            { header: "", key: "due_demandable", width: 17 },
            { header: "", key: "not_yet_due", width: 17 },
            { header: "", key: "ors_caa_number", width: 27 }
        ];

        this.setHeader(ws, selected_campus, fund_name, allotment_class, year);

        let position = this.initialPosition + 2;
        let amt_columnn = ['E', 'F', 'G', 'H', 'I', 'J'];
        let amt_property = [
            'budgeted_amount',
            'utilization',
            'unutilized_budgeted_amount',
            'disbursement',
            'due_demandable',
            'not_yet_due'
        ];
        data.forEach((data: any, i: number) => {
            amt_property.forEach((prop: string, index: number) => {
                data[prop] = (Number(data[prop]) == 0) ? "" : Number(data[prop]);
            });

            data.date1 = this.formatDate(data.date1);
            data.date2 = this.formatDate(data.date2);

            ws.addRow(data);

            let rowNum = position + i;
            this.columns.forEach((col: string) => {
                let cell = ws.getCell(`${col}${rowNum}`);
                if (amt_columnn.includes(col)) {
                    if (['G', 'J'].includes(col)) {
                        if ((rowNum > 11)) {
                            cell.value = { formula: `IF(${col}${rowNum - 1}="",0,${col}${rowNum - 1}) + ${this.formula[col.toLowerCase()].replaceAll('*', rowNum)}`, date1904: false };
                        }
                    }
                    cell.style = { numFmt: this.numberFormat };
                }
                cell.font = this.fontStyle.content;
                cell.border = this.borderStyle.full;
                cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
            });
        });

        this.columns.forEach((col: string) => {
            let cell = ws.getCell(`${col}${position + data.length}`);
            let is_amt = false;
            if (amt_columnn.includes(col)) {
                cell.value = ws.getCell(`${col}${position + data.length - 1}`).value;
                if (!['G', 'J'].includes(col)) {
                    cell.value = { formula: `SUM(${col}${position}:${col}${position + data.length - 1})`, date1904: false };
                }
                cell.style = { numFmt: this.numberFormat };
                is_amt = true;
            }
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (is_amt) ? 'right' : 'center' };
        });

        ws.mergeCells(`A${position + data.length}:D${position + data.length}`);
        ws.getCell(`A${position + data.length}`).value = `Total`;

        // Add CAA earmark data if available
        if (caa_data && caa_data.length > 0) {
            let caaPosition = position + data.length + 1;
            let amt_columnn = ['E', 'F', 'G', 'H', 'I', 'J'];

            // Add spacer and header for CAA section
            ws.addRow({});
            let rowNum = caaPosition;
            this.columns.forEach((col: string) => {
                let cell = ws.getCell(`${col}${rowNum}`);
                if (col === 'A') {
                    cell.value = 'Earmark Budget with Certificate of Availability of Allotment';
                }
                if (amt_columnn.includes(col)) {
                    cell.style = { numFmt: this.numberFormat };
                }
                cell.font = this.fontStyle.content;
                cell.border = this.borderStyle.full;
                cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
            });
            ws.mergeCells(`A${rowNum}:C${rowNum}`);

            // Process CAA data
            let caa_earmark_data = [];
            caaPosition += 1;
            let initCaaPosition = caaPosition;

            caa_data.forEach((caaItem: any) => {
                let orsForCaa = data.filter((d: any) => d.ors_caa_number == caaItem.caa_no);

                caa_earmark_data.push({
                    date1: caaItem.caa_date,
                    date2: caaItem.caa_date,
                    serial_number: caaItem.caa_no,
                    uacs_expenditures: caaItem.acct_uacs_code,
                    budgeted_amount: '',
                    utilization: Number(caaItem.amount),
                    unutilized_budgeted_amount: '',
                    disbursement: '',
                    due_demandable: '',
                    not_yet_due: '',
                    ors_caa_number: orsForCaa.map(ors => ors.serial_number).join(', ') || '',
                });

                // Add corresponding ORS entries (negative amounts)
                for (let i = 0; i < orsForCaa.length; i++) {
                    caa_earmark_data.push({
                        date1: orsForCaa[i].date1,
                        date2: orsForCaa[i].date2,
                        serial_number: orsForCaa[i].serial_number,
                        uacs_expenditures: orsForCaa[i].uacs_expenditures,
                        budgeted_amount: '',
                        utilization: Number(orsForCaa[i].utilization) * -1,
                        unutilized_budgeted_amount: '',
                        disbursement: '',
                        due_demandable: '',
                        not_yet_due: '',
                        ors_caa_number: '',
                    });
                }
            });

            // Sort CAA data by date
            let sorted_caa = caa_earmark_data.sort((a, b) => {
                const dateA = new Date(a.date1);
                const dateB = new Date(b.date1);
                if (dateA.getTime() !== dateB.getTime()) {
                    return dateA.getTime() - dateB.getTime();
                }
                return new Date(a.date2).getTime() - new Date(b.date2).getTime();
            });

            // Add CAA rows to worksheet
            sorted_caa.forEach((caaData: any, i: number) => {
                caaData.date1 = this.formatDate(caaData.date1);
                caaData.date2 = this.formatDate(caaData.date2);
                
                ws.addRow(caaData);
                let rowNum = caaPosition + i;
                this.columns.forEach((col: string) => {
                    let cell = ws.getCell(`${col}${rowNum}`);
                    if (col == 'G') {
                        let rn = (i == 0) ? rowNum - 2 : rowNum - 1;
                        cell.value = { formula: `IF(G${rn}="",0,G${rn}) - IF(F${rowNum}="",0,F${rowNum})`, date1904: false };
                    }
                    if (amt_columnn.includes(col)) {
                        cell.style = { numFmt: this.numberFormat };
                    }
                    cell.font = this.fontStyle.content;
                    cell.border = this.borderStyle.full;
                    cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
                });
            });

            // Add CAA total row
            ws.addRow({});
            caaPosition += sorted_caa.length;
            this.columns.forEach((col: string) => {
                let cell = ws.getCell(`${col}${caaPosition}`);
                if (col === 'A') {
                    cell.value = 'Total';
                }
                if (col == 'G') {
                    cell.value = { formula: `G${caaPosition - 1}`, date1904: false };
                }
                if (col == 'F') {
                    cell.value = { formula: `SUM(F${initCaaPosition}:F${caaPosition - 1})`, date1904: false };
                }
                if (amt_columnn.includes(col)) {
                    cell.style = { numFmt: this.numberFormat };
                }
                cell.font = this.fontStyle.header;
                cell.border = this.borderStyle.full;
                cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (!amt_columnn.includes(col)) ? 'center' : 'right' };
            });
            ws.mergeCells(`A${caaPosition}:D${caaPosition}`);
        }

        const arrayData = await wb.xlsx.writeBuffer();
        const blob = new Blob([arrayData], { type: "application/octet-binary" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${options.fileName}.xlsx`;
        a.click();
        a.remove();
    }

    private setHeader(ws: ExcelJS.Worksheet, campus: any, fund_name: string, allotment_class: string, year: any) {
        let position = this.initialPosition;

        // header title
        ws.mergeCells(`A1:J1`);
        let rowA1 = ws.getCell(`A1`);
        rowA1.value = "REGISTRY OF BUDGET, UTILIZATIONS AND DISBURSEMENTS";
        rowA1.font = this.fontStyle.header;
        rowA1.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A2:J2`);
        let rowA2 = ws.getCell(`A2`);
        rowA2.value = allotment_class.toUpperCase();
        rowA2.font = this.fontStyle.header;
        rowA2.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A3:J3`);
        let rowA3 = ws.getCell(`A3`);
        rowA3.value = `For the year ${year}`;
        rowA3.font = this.fontStyle.header;
        rowA3.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A5:B5`);
        let rowA5 = ws.getCell(`A5`);
        rowA5.value = `Entity Name:`;
        rowA5.font = this.fontStyle.header;
        rowA5.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.mergeCells(`C5:F5`);
        let entity = ws.getCell(`C5`);
        entity.value = `BATANGAS STATE UNIVERSITY - ${campus.details.name}`;
        entity.font = this.fontStyle.header;
        entity.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        let rowG5 = ws.getCell(`G5`);
        rowG5.value = `MFO/PAP:`;
        rowG5.font = this.fontStyle.header;
        rowG5.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.mergeCells(`H5:J6`);
        let mfo_pap = ws.getCell(`H5`);
        mfo_pap.value = `${fund_name}`;
        mfo_pap.font = this.fontStyle.header;
        mfo_pap.alignment = { wrapText: true, vertical: "top", horizontal: "left" };

        ws.mergeCells(`A6:B6`);
        let rowA6 = ws.getCell(`A6`);
        rowA6.value = `Fund Cluster:`;
        rowA6.font = this.fontStyle.header;
        rowA6.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.mergeCells(`C6:D6`);
        let fund_cluster = ws.getCell(`C6`);
        fund_cluster.value = ``;
        fund_cluster.font = this.fontStyle.header;
        fund_cluster.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.mergeCells(`A7:B7`);
        let rowA7 = ws.getCell(`A7`);
        rowA7.value = `Legal Basis:`;
        rowA7.font = this.fontStyle.header;
        rowA7.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.mergeCells(`C7:D7`);
        let legal_basis = ws.getCell(`C7`);
        legal_basis.value = `${env.realignment_legal_basis[year]}`;
        legal_basis.font = this.fontStyle.header;
        legal_basis.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        let rowG7 = ws.getCell(`G7`);
        rowG7.value = `Sheet No:`;
        rowG7.font = this.fontStyle.header;
        rowG7.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        // let colExceptions = ['AF', 'AG'];
        this.columns.forEach((c: string, i: number) => {

            if (c == 'B') {
                ws.mergeCells(`B${position}:C${position}`);
                let reference = ws.getCell(`B${position}`);
                reference.value = `Reference`;
                reference.font = this.fontStyle.header;
                reference.border = this.borderStyle.full;
                reference.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };

                let date = ws.getCell(`B${position + 1}`);
                date.value = this.columnTitle[i];
                date.font = this.fontStyle.header;
                date.border = this.borderStyle.full;
                date.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
                return;
            }

            if (c == 'C') {
                let sn = ws.getCell(`C${position + 1}`);
                sn.value = this.columnTitle[i];
                sn.font = this.fontStyle.header;
                sn.border = this.borderStyle.full;
                sn.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
                return;
            }

            if (c == 'I') {
                ws.mergeCells(`I${position}:J${position}`);
                let reference = ws.getCell(`I${position}`);
                reference.value = `Unpaid Utilization`;
                reference.font = this.fontStyle.header;
                reference.border = this.borderStyle.full;
                reference.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };

                let due_demandable = ws.getCell(`I${position + 1}`);
                due_demandable.value = this.columnTitle[i];
                due_demandable.font = this.fontStyle.header;
                due_demandable.border = this.borderStyle.full;
                due_demandable.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
                return;
            }
            if (c == 'J') {
                let sn = ws.getCell(`J${position + 1}`);
                sn.value = this.columnTitle[i];
                sn.font = this.fontStyle.header;
                sn.border = this.borderStyle.full;
                sn.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
                return;
            }

            ws.mergeCells(`${c}${position}:${c}${position + 1}`);
            let col = ws.getCell(`${c}${position}`);
            col.value = this.columnTitle[i];
            col.font = this.fontStyle.header;
            col.border = this.borderStyle.full;
            col.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
        });

    }


    private formatDate(date: any) {
        let d = new Date(date);
        let month = env.short_months[d.getMonth()];
        let day: any = d.getDate();
        let year = d.getFullYear();
        if (day < 10) {
            day = `0${day}`;
        }
        return `${day}-${month}-${year}`;
    }
}
